import React from "react";
import { brl, fmtDate } from "@/lib/api";
import { CalendarRange } from "lucide-react";

export const MetaSemanal = ({ week }) => {
  if (!week) return null;
  const max = Math.max(1, ...week.dias.map((d) => Math.max(d.previsto, d.recebido)));
  return (
    <div className="trt-card p-5 space-y-4" data-testid="meta-semanal">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div className="flex items-center gap-2 font-bold"><CalendarRange className="w-5 h-5 text-amber-600" /> Resumo da Semana</div>
        <div className="text-xs text-slate-500">
          Recebido <b className="text-emerald-600">{brl(week.total_recebido)}</b> de <b>{brl(week.total_previsto)}</b> previstos
        </div>
      </div>
      <div className="grid grid-cols-7 gap-2 week-strip" data-testid="semana-strip">
        {week.dias.map((d) => (
          <div key={d.data} className={`rounded-lg p-2 text-center min-w-0 overflow-hidden ${d.hoje ? "bg-onyx text-white gold-border" : "bg-slate-50"}`}
            data-testid={`semana-dia-${d.data}`} title={fmtDate(d.data)}>
            <div className={`text-[11px] font-bold num-nowrap ${d.hoje ? "gold-text" : "text-slate-600"}`}>{d.dia} <span className="font-normal opacity-70">{d.data.slice(8, 10)}</span></div>
            <div className="flex items-end justify-center gap-1.5 h-16 mt-1">
              <div className="w-3 rounded-t bg-slate-300" style={{ height: `${Math.max(2, (d.previsto / max) * 100)}%` }} title={`Previsto ${brl(d.previsto)}`} />
              <div className="w-3 rounded-t bg-emerald-500" style={{ height: `${Math.max(2, (d.recebido / max) * 100)}%` }} title={`Recebido ${brl(d.recebido)}`} />
            </div>
            <div className="text-[10px] text-emerald-600 font-semibold mono num-nowrap mt-1" data-testid={`semana-recebido-${d.data}`}>{brl(d.recebido)}</div>
            <div className={`text-[10px] mono num-nowrap ${d.hoje ? "text-slate-300" : "text-slate-400"}`} data-testid={`semana-previsto-${d.data}`}>{brl(d.previsto)}</div>
          </div>
        ))}
      </div>
      <div className="flex gap-4 text-[11px] text-slate-500">
        <span className="flex items-center gap-1"><i className="w-2.5 h-2.5 rounded-sm bg-slate-300 inline-block" /> Previsto</span>
        <span className="flex items-center gap-1"><i className="w-2.5 h-2.5 rounded-sm bg-emerald-500 inline-block" /> Recebido</span>
      </div>
    </div>
  );
};
